import React, { useState } from 'react';
import Icon from '../IconBase/Icon';
import { translate } from '../../Services/translation';

const JSONparse = (value, defaultValue) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return defaultValue;
  }
};

const Faq = ({
  question,
  answer,
  icon,
  items,
  showMore = false,
  defaultExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const [answerExpanded, setAnswerExpanded] = useState(!showMore);
  const itemsArr = JSONparse(items, []);

  const onClick = (e) => {
    setExpanded(!expanded);
  };

  const onAnswerExpandClick = (e) => {
    setAnswerExpanded(!answerExpanded);
  };

  return (
    <div
      className={`faq-block__item ${
        expanded ? 'faq-block__item--expanded' : ''
      }`}
    >
      <div
        className={`faq-block__question ${
          icon ? 'faq-block__question--has-icon' : ''
        }`}
        onClick={onClick}
      >
        {icon && <Icon iconCode={icon} className="faq-block__item__icon" />}
        <span className="faq-block__item-title">{question}</span>
        <Icon
          iconCode={expanded ? 'expand_less' : 'expand_more'}
          className="faq-block__item__expand"
        />
      </div>
      <div
        className={`faq-block__answer ${
          showMore ? 'faq-block__answer--has-show-more' : ''
        }`}
      >
        <div
          className={`faq-block__answer__inner ${
            answerExpanded ? 'faq-block__answer__inner--expanded' : ''
          }`}
          onClick={(e) => showMore && !answerExpanded && onAnswerExpandClick(e)}
        >
          {answer && <div dangerouslySetInnerHTML={{ __html: answer }}></div>}
          {itemsArr && itemsArr.length > 0 && (
            <div className="faq-block faq-block--default">
              {itemsArr &&
                itemsArr.length > 0 &&
                itemsArr.map((item, i) => (
                  <Faq
                    key={'item-' + i}
                    question={item.question}
                    answer={item.answer}
                    icon={item.icon ?? ''}
                    showMore={item.showMore ?? false}
                    defaultExpanded={item.defaultExpanded ?? false}
                  />
                ))}
            </div>
          )}
        </div>
        {showMore && (
          <div
            className="faq-block__answer__show-more"
            onClick={onAnswerExpandClick}
          >
            {answerExpanded
              ? translate('toggle.showless')
              : translate('toggle.showmore')}
          </div>
        )}
      </div>
    </div>
  );
};

export default Faq;
